module.exports = __webpack_public_path__ + "img/play-button.bc93a851.svg";